var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar28(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-27",
    "data-name": "50_Kids_Icons-27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#ffc34a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504",
    transform: "translate(22.735 37.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M152.22,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.2,244.065,152.22,246.493Z",
    transform: "translate(-145.502 -242.885)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M319.274,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S320.3,244.065,319.274,246.492Z",
    transform: "translate(-291.689 -242.885)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 20.206,
    cy: 18.496,
    rx: 20.206,
    ry: 18.496,
    transform: "translate(19.078 11.399)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M127.671,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-58.784 -326.964)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M226.252,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-179.77 -214.962)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(25.077 18.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M190.112,141.985A15.048,15.048,0,0,1,175.3,157.274h0a15.049,15.049,0,0,1-14.812-15.289v-8.813A15.055,15.055,0,0,1,175.3,117.885h0a15.054,15.054,0,0,1,14.807,15.287Z",
    transform: "translate(-160.493 -117.885)",
    fill: "#d67f5e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M129.117,425.067c0-8-2.995-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-60.012 -339.904)",
    fill: "#9ec853"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(33.208 43.025)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(10.263)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M243.7,289.356a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.517,2.517,0,0,0,243.7,289.356Z",
    transform: "translate(-201.603 -244.144)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(31.625 39.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M203.585,255.809a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-202.398 -253.699)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508",
    transform: "translate(11.739 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M282.094,254.84a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-277.528 -253.699)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M144.555,177.29h0a3.828,3.828,0,0,1-3.828-3.828v-8.75a3.828,3.828,0,0,1,3.828-3.828h0a3.828,3.828,0,0,1,3.828,3.828v8.75A3.828,3.828,0,0,1,144.555,177.29Z",
    transform: "translate(-118.738 -135.746)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M186.8,129.477h0a4.339,4.339,0,0,1-4.339-4.339v-9.917a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,186.8,129.477Z",
    transform: "translate(-153.951 -93.558)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M231.8,120.477h0a4.339,4.339,0,0,1-4.339-4.339v-9.917a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,231.8,120.477Z",
    transform: "translate(-191.919 -85.964)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M276.8,130.477h0a4.339,4.339,0,0,1-4.339-4.339v-9.917a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,276.8,130.477Z",
    transform: "translate(-229.888 -94.401)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M324.555,172.29h0a3.828,3.828,0,0,1-3.828-3.828v-8.75a3.828,3.828,0,0,1,3.828-3.828h0a3.828,3.828,0,0,1,3.828,3.828v8.75A3.828,3.828,0,0,1,324.555,172.29Z",
    transform: "translate(-270.613 -131.527)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 15.625,
    cy: 6.25,
    rx: 15.625,
    ry: 6.25,
    transform: "translate(23.551 18.107)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(34.627 49.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M221.616,318.136c0,.029,0,.062,0,.092a5.373,5.373,0,1,0,10.746,0c0-.031,0-.064,0-.092Z",
    transform: "translate(-221.614 -318.136)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M232.542,318.136v.46a1.687,1.687,0,0,0,1.687,1.688h5.527a1.688,1.688,0,0,0,1.689-1.688v-.46Z",
    transform: "translate(-230.835 -318.136)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar28);
export default __webpack_public_path__ + "static/media/avatar28.bf0bf4f78bc41790f17657c9152fe7ff.svg";
export { ForwardRef as ReactComponent };